import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import PayslipView from "@/components/PayslipView";
import { FileText, Eye } from "lucide-react";

export default function MyPayslips() {
  const [items, setItems] = useState([]);
  const [emp, setEmp] = useState(null);
  const [viewing, setViewing] = useState(null);

  useEffect(() => {
    (async () => {
      const [a, b] = await Promise.all([
        api.get("/payslips"),
        api.get("/employees/me").catch(() => ({ data: null })),
      ]);
      setItems(a.data);
      setEmp(b.data);
    })();
  }, []);

  return (
    <AdminLayout title="My Payslips" breadcrumbs={["Home", "Self Service", "Payslips"]}>
      <div className="bg-white border border-slate-200 rounded shadow-sm">
        <div className="px-5 py-3.5 border-b border-slate-200 flex items-center justify-between">
          <h3 className="text-base font-semibold text-slate-800 flex items-center gap-2">
            <FileText className="h-5 w-5 text-[#226DB4]" /> My Payslips
          </h3>
        </div>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-4 py-3 font-semibold">Period</th>
              <th className="text-left px-4 py-3 font-semibold">Paid Days</th>
              <th className="text-right px-4 py-3 font-semibold">Gross</th>
              <th className="text-right px-4 py-3 font-semibold">Deductions</th>
              <th className="text-right px-4 py-3 font-semibold">Net Pay</th>
              <th className="text-right px-4 py-3 font-semibold">Action</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-4 py-12 text-center text-slate-400" data-testid="my-payslips-empty">
                  No payslips available yet
                </td>
              </tr>
            ) : (
              items.map((p) => (
                <tr key={p.id} className="border-t border-slate-100 hover:bg-slate-50/60">
                  <td className="px-4 py-3 font-medium text-slate-800">{p.period_label}</td>
                  <td className="px-4 py-3 text-slate-600">
                    {p.paid_days} / {p.working_days}
                  </td>
                  <td className="px-4 py-3 text-right text-slate-700">
                    ₹{p.gross_earnings.toLocaleString("en-IN")}
                  </td>
                  <td className="px-4 py-3 text-right text-rose-600">
                    ₹{p.total_deductions.toLocaleString("en-IN")}
                  </td>
                  <td className="px-4 py-3 text-right font-semibold text-emerald-700">
                    ₹{p.net_pay.toLocaleString("en-IN")}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button
                      onClick={() => setViewing(p)}
                      data-testid={`view-my-payslip-${p.period_label.replace(" ", "-")}`}
                      className="inline-flex items-center gap-1 px-3 py-1.5 text-xs border border-slate-200 rounded hover:bg-slate-50"
                    >
                      <Eye className="h-3.5 w-3.5" /> View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {viewing && (
        <PayslipView
          payslip={viewing}
          employee={emp}
          onClose={() => setViewing(null)}
        />
      )}
    </AdminLayout>
  );
}
